import type { FC } from 'react'
import styled from '@emotion/styled'

import ButtonText from '@segment/matcha/components/ButtonText'

import { ChevronRightIcon } from '@segment/matcha/components/Icons/Common'

import CopyTextBase, * as CopyText from '@segment/matcha/recipes/CopyText'
import SectionBase, * as Section from '@segment/matcha/recipes/Section'

import Faq from './Faq'

const copy = {
  title: `Choose your own journey`,
  description: `Grow and retain across the customer lifecycle with our standard starter templates.`,
}

const link = {
  text: `Learn more about Journeys`,
  url: `https://learn.segment.com/journeys-orchestrating-omnichannel-engagement/`,
}

const ChooseYourOwnJourney: FC = () => {
  return (
    <SectionBaseWrapper variant="noCopy">
      <Section.Contents>
        <StyledSectionBase variant="centered">
          <CopyTextBase>
            <Section.Copy>
              <CopyText.Heading>{copy.title}</CopyText.Heading>
              <CopyText.Description>{copy.description}</CopyText.Description>
            </Section.Copy>
          </CopyTextBase>
          <Section.Contents>
            <Faq />
          </Section.Contents>
          <ButtonText tag="a" href={link.url} iconEnd={ChevronRightIcon}>
            {link.text}
          </ButtonText>
        </StyledSectionBase>
      </Section.Contents>
    </SectionBaseWrapper>
  )
}

export default ChooseYourOwnJourney

const SectionBaseWrapper = styled(SectionBase)`
  ${Section.Wrapper} {
    ${({ theme }) => theme.breakpoints.up(`md`)} {
      padding-top: 0;
      padding-bottom: 0;
    }
  }
`

const StyledSectionBase = styled(SectionBase)`
  ${Section.Wrapper} {
    padding-top: 0;
    row-gap: 48px;
    ${({ theme }) => theme.breakpoints.up(`md`)} {
      row-gap: 72px;
      padding-top: 80px;
      padding-bottom: 120px;
    }
    ${({ theme }) => theme.breakpoints.down(`md`)} {
      text-align: left;
    }
    ${({ theme }) => theme.breakpoints.down(`xs`)} {
      padding: 0 0 50px;
    }
  }
  ${Section.Contents} {
    justify-content: left;
    max-width: 832px;
    ${({ theme }) => theme.breakpoints.down(`md`)} {
      text-align: center;
      max-width: 751px;
    }
  }
  ${Section.Copy} {
    ${({ theme }) => theme.breakpoints.up(`lg`)} {
      min-width: 832px;
    }
  }
`
